export function authRoles(state) {
  return state.auth.roles
}